import { css } from '@emotion/core'
import { mediumUp } from 'Utils'
import theme from 'Theme'

const { colors, mixins, typography } = theme

export default () => css`
  display: inline-block;
  min-width: 140px;
  min-height: 42px;
  ${mixins.defaultButtonPadding()}
  vertical-align: middle;
  text-align: center;
  line-height: 1em;
  background-color: ${colors.primary};
  color: ${colors.complementary.primary};
  transition: background-color 100ms ease-in, color 100ms ease-in;
  font-size: ${typography.baseFontSize};
  span {
    line-height: 1em;
  }

  @media ${mediumUp} {
    &:hover {
      background-color: ${colors.loading.button.hover.backgroundColor};
      color: ${colors.complementary.primary};
    }
  }

  /* props.useLoader is false */
  &.loading {
  }

  /* props.useLoader is true */
  &.loading--use-loader {
    background-color: ${colors.body};
    .spinner {
      margin: 0 auto;
      width: 50px;
      text-align: center;
      position: relative;
      display: flex;
      justify-content: space-between;
    }

    .spinner > div {
      width: 12px;
      height: 12px;
      background-color: ${colors.bodyBackground};

      border-radius: 100%;
      display: inline-block;
      -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
      animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    }

    .spinner .bounce1 {
      -webkit-animation-delay: -0.32s;
      animation-delay: -0.32s;
    }

    .spinner .bounce2 {
      -webkit-animation-delay: -0.16s;
      animation-delay: -0.16s;
    }
  }

  @-webkit-keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1);
    }
  }

  @keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }
`
